import { useQuery } from "@tanstack/react-query";
import { useIsApiReady } from "../hooks/use-api-ready";
import { groupExpertControllerGetExpertSkills } from "../lib/gen-api";
import { queryKeys } from "../lib/query-keys";

export const useExpertSkillsSummaryData = (
  groupUuid: string | null,
  expertUuid: string | null,
) => {
  const {
    data: skillsData,
    isPending,
    isPlaceholderData,
  } = useQuery({
    enabled: useIsApiReady() && !!groupUuid && !!expertUuid,
    queryKey: queryKeys.expertSkillsSummary(groupUuid!, expertUuid!),
    staleTime: 60 * 1000,
    queryFn: async () => {
      const response = await groupExpertControllerGetExpertSkills({
        path: {
          groupUuid: groupUuid!,
          expertUuid: expertUuid!,
        },
      });
      return response.data;
    },
  });

  const skills =
    !expertUuid || isPending || isPlaceholderData
      ? []
      : (skillsData?.data ?? []);
  const isLoading = !groupUuid || !expertUuid || isPending;

  return {
    skills,
    isLoading,
  };
};
